import script from "./lanmujieshao.vue?vue&type=script&setup=true&lang=js"
export * from "./lanmujieshao.vue?vue&type=script&setup=true&lang=js"

import "./lanmujieshao.vue?vue&type=style&index=0&id=55a331f1&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\kepukeyanchengguozhanshi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55a331f1"]])

export default __exports__